import { getFieldValue } from "@digitallab/grid-common-components";

const LinkedInstanceRender = (params) => {
  return <>{getFieldValue(params?.data, "linked_instance")}</>;
};

export default LinkedInstanceRender;
